$(document).ready(function(){
     // default filters 
     $('#default_sort').on('change', function() {
        var sort = $(this).val();
        // console.log('sort ' + sort);
        var min_price = $('#min_price').val();
        var max_price = $('#max_price').val();
        var collection = $('.current_collection').val();
        var vendor_name = '';
        var product_type = '';
        $("input:checkbox[name=filter-p-vendor]:checked").each(function(){
            vendor_name += '&filter.p.vendor=' + $(this).val();
        });
        $("input:checkbox[name=filter-p-product_type]:checked").each(function(){
            product_type += '&filter.p.product_type=' + $(this).val();
        });

        var url = "/collections/" + collection +
        "?filter.v.availability=" + 
        "&filter.v.price.gte=" + min_price + 
        "&filter.v.price.lte=" + max_price + vendor_name + product_type + 
        "&sort_by=" + sort;

        var filter_url = collection +
        "?filter.v.availability=" + 
        "&filter.v.price.gte=" + min_price + 
        "&filter.v.price.lte=" + max_price + vendor_name + product_type + 
        "&sort_by=" + sort;

        window.history.pushState({}, null, filter_url);

        fetch(url)
        .then(response => response.text())
        .then(infoData => {
            var products = $(infoData);
            var items = $('#product-grid' , products);
            var filters = $('.product-filters' , products);
            $('#product-grid').replaceWith(items);
            $('.product-filters').replaceWith(filters);
        });
    })

    // for vendor and product type ajax
    $('li.filter-link input').on('change', function(e){
        e.preventDefault();
        var vendor_name = '';
        var product_type = '';
        $("input:checkbox[name=filter-p-vendor]:checked").each(function(){
            vendor_name += '&filter.p.vendor=' + $(this).val();
        });
        $("input:checkbox[name=filter-p-product_type]:checked").each(function(){
            product_type += '&filter.p.product_type=' + $(this).val();
        });
        var sort = $('#default_sort').find(":selected").val();
        var min_price = $('#min_price').val();
        var max_price = $('#max_price').val();
        var collection = $('.current_collection').val();
        var url = "/collections/" + collection +
        "?filter.v.availability=" + 
        "&filter.v.price.gte=" + min_price + 
        "&filter.v.price.lte=" + max_price + vendor_name + product_type + 
        "&sort_by=" + sort;

        var filter_url = collection +
        "?filter.v.availability=" + 
        "&filter.v.price.gte=" + min_price + 
        "&filter.v.price.lte=" + max_price + vendor_name + product_type + 
        "&sort_by=" + sort;

        window.history.pushState({}, null, filter_url);

        fetch(url)
        .then(response => response.text())
        .then(infoData => {
            var products = $(infoData);
            var items = $('#product-grid' , products);
            var filters = $('.product-filters' , products);
            $('#product-grid').replaceWith(items);
            $('.product-filters').replaceWith(filters);
        });

    })


    // for price ajax
    $('.filter_price').on('keyup', function(){
        setTimeout(function() { 
            var vendor_name = '';
            var product_type = '';
            $("input:checkbox[name=filter-p-vendor]:checked").each(function(){
                vendor_name += '&filter.p.vendor=' + $(this).val();
            });
            $("input:checkbox[name=filter-p-product_type]:checked").each(function(){
                product_type += '&filter.p.product_type=' + $(this).val();
            });
            var sort = $('#default_sort').find(":selected").val();
            var min_price = $('#min_price').val();
            var max_price = $('#max_price').val();
            var collection = $('.current_collection').val();
    
            var url = "/collections/" + collection +
            "?filter.v.availability=" + 
            "&filter.v.price.gte=" + min_price + 
            "&filter.v.price.lte=" + max_price + vendor_name + product_type + 
            "&sort_by=" + sort;
    
            var filter_url = collection +
            "?filter.v.availability=" + 
            "&filter.v.price.gte=" + min_price + 
            "&filter.v.price.lte=" + max_price + vendor_name + product_type + 
            "&sort_by=" + sort;
    
            window.history.pushState({}, null, filter_url);

            var parms = new window.URLSearchParams(window.location.href);

            // var mn_price = parms.get('filter.v.price.gte');
            // var mx_price = parms.get('filter.v.price.lte');

            if(max_price != null) {
                $('#max_price').val(mx_price);
            }
            if(min_price != null) {
                $('#min_price').val(min_price);
            } 
            console.log('work')
            fetch(url)
            .then(response => response.text())
            .then(infoData => {
                var products = $(infoData);
                var items = $('#product-grid' , products);
                var filters = $('.product-filters' , products);
                $('#product-grid').replaceWith(items);
                $('.product-filters').replaceWith(filters);
            });

        }, 1500);
        
    })

    var parms = new window.URLSearchParams(window.location.href);
    var mn_price = parms.get('filter.v.price.gte');
    var mx_price = parms.get('filter.v.price.lte');

    // console.log('mn_price ' + mn_price);
    // console.log('mx_price ' + mx_price);

    if(mx_price != null) {
        $('#max_price').val(mx_price);
    }
    if(mn_price != null) {
        $('#min_price').val(mn_price);
    } 
   
    $('.filter-title').on('click', function(){
        $(this).next().slideToggle(); 
    })
    
    $('span.filter-icon').on('click', function(){
        $('body').addClass('filter_shown'); 
    })

    $('span.filter-close, .filter-overly').on('click', function(){
        $('body').removeClass('filter_shown');
    })


    // sticky button 
    $(window).scroll(function() {
        var top_of_element = $("#main_header").offset().top;
        var bottom_of_element = $("#main_header").offset().top + $("#main_header").outerHeight();
        var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
        var top_of_screen = $(window).scrollTop();

        var top_of_element2 = $("footer").offset().top;
        var bottom_of_element2 = $("footer").offset().top + $("footer").outerHeight();

        if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
            $(".product-filters").removeClass('sticky');
        } else if ((bottom_of_screen > top_of_element2) && (top_of_screen < bottom_of_element2)){
            $(".product-filters").removeClass('sticky');
        } else {
            $(".product-filters").addClass('sticky');
        }
    }); 
    
})
